import type { ComputedRef, Ref } from 'vue';
import { computed } from 'vue';
import { some } from 'underscore';

export default function combinedBooleanRef(
  ...input: Ref<boolean>[]
): ComputedRef<boolean> {
  return computed<boolean>(() => some(input.map(item => item.value)));
}
